function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 109.5,
  r: 103,
  fill: "#5AE6D9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M156.5 92L165.5 111.5L185 123L211.5 120L228.5 105.5L227.5 97L219.5 93L210.5 90V74L217.5 66.5L222.5 60L224.5 59C226.667 58.5 228.5 57.1 230.5 55.5C232.5 53.9 232.333 50.5 232 49L229.5 45L227 43.5L222 33L208 21.5L190 18L173.5 25.5L166.5 39.5L165.5 40.5L163 42.5C162.333 43.6667 161 46.1 161 46.5C161 46.9 161.667 50 162 51.5L165.5 55L167.5 56L170 62.5L173 69L178.5 74.5V79.5C178.5 82.3 177.167 87.6667 176.5 90L165.5 89.5L156.5 92ZM6 93L4.5 95.5L6.5 99.5L9.5 104.5L14.5 110.5L17.5 113L21.5 114.5C24.5 115 31.3 116.1 34.5 116.5C37.7 116.9 38.5 117.667 38.5 118L49.5 130L65 147L77 160L86.5 170.5L92 176L98 179L103.5 180.5L107 180L112 178L141 164L143 155.5L115 122H113.5L108.5 125.5L103.5 129.5L101.5 129L91 120.5L82 112.5L71 103.5L59 95L52.5 93.5L48.5 94.5L45.5 95.5L43 92.5L38.5 87.5L35 85H32L30 87.5L31 92L32.5 96L33 98.5L30.5 100L28.5 99.5L27 98.5L25 96L23 95.5L20 97L18.5 94.5L15.5 93.5L13 94.5H10.5L8.5 93H6ZM216 178L269.5 169L271.5 171.5L278 194.5L281 210V212.5H219L216 178Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M186.5 44.5C186.167 46.6667 185.5 51.4 185.5 53C185.5 55 186.5 55.5 188 55.5",
  stroke: "black",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M178.5 74C178.5 73.6667 178.5 73.2 178.5 78C178.5 82.8 177.167 88 176.5 90C172.5 89.3333 161 89.6 155 92",
  stroke: "black",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M210.5 94V74",
  stroke: "black",
  strokeWidth: 2
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M56 104.5C54.5 101.833 49.6 96.5 42 96.5C32.5 96.5 30 103.273 21.5 102.5C15.5 101.955 12 93.5 7.99998 93C3.53473 92.4418 4.99998 96.5 4.99998 96.5C4.99998 96.5 12.5 111 19 113.5C25.5 116 32 116.5 42 116.5",
  stroke: "black",
  strokeWidth: 2
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M12 95C12.3333 94.5 13.4 93.5 15 93.5C19.5 93.5 21 99.5 24.5 102.5",
  stroke: "black",
  strokeWidth: 2
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M21 98C21 97.3333 20.5 95.5 23.5 95.5C26.5 95.5 27 99 30 100.5",
  stroke: "black",
  strokeWidth: 2
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5 98.5C33 96.8333 31.7155 93.2522 31 92C29 88.5 30.5 86 32.5 85C35.7557 83.372 39.2788 88.2419 42.5 92C45.5 95.5 46.5 97 50.5 99",
  stroke: "black",
  strokeWidth: 2
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M46 96C46.6667 95.1667 49.2 93.5 54 93.5C58.8 93.5 70.6667 103.167 76 108L103.5 130",
  stroke: "black",
  strokeWidth: 2
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M114 122L89.5 139.5",
  stroke: "black",
  strokeWidth: 2
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M37 116.5L89.5 174C92.8333 177.333 101.8 182.9 111 178.5C120.2 174.1 135.5 166.667 142 163.5",
  stroke: "black",
  strokeWidth: 2
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M271 169.5C273.5 178.167 279 201 281 212.5",
  stroke: "black",
  strokeWidth: 2
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M142 155.5L108.5 115.5C111.167 113.5 119.4 107.8 131 101C142.6 94.2 153.833 90.8333 158 90C160.333 99.5 170.5 118.5 192.5 118.5C214.5 118.5 225 103.5 227.5 96C231.667 97.8333 243.1 104.9 255.5 118.5C267.9 132.1 273 158.167 274 169.5C272.167 170.333 265.6 172.7 254 175.5C242.4 178.3 235.833 179.333 229 179.5L235 212.5H134L142 155.5Z",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M168 39.5C164.667 39.8333 162 41.1 162 47.5C162 50.5 164.333 55.5 167.5 55.5C170.5 63 172.5 78 193 78C213.5 78 218.5 65.3333 223 59C227 59.1667 232 57.7 232 50.5C232 43.3 227.667 42.8333 224 43.5",
  stroke: "black",
  strokeWidth: 2
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M161 35C161.958 39.3129 165.833 40.5 168 40.5C168.667 40.5 170.6 39.9 173 37.5C175.4 35.1 175.667 30.5 175.5 28.5C176.167 28.6667 179.5 28.5 182.5 27C187.885 24.3076 189.158 22.0161 189.991 20.5158L190 20.5C190.833 21.8333 192.5 26 198 29C204 32.2727 210.833 31.5 214.5 30.5C214 30.8333 213.5 34 214.5 37.5C215.859 42.2574 220.667 44.1667 223 44.5C225.667 44.6667 231 42.7 231 33.5C231 24.3 224.333 21.6667 221 21.5C221.333 20.3333 222 18 221.5 14.5C221 11 218 5.5 210 5.5C204.975 5.5 203.833 7.83333 203 9C201.5 6 196.7 0 189.5 0C182.3 0 178.5 5 178.5 8.5C175.5 8 173.5 7.5 170 10.5C165.869 14.0407 166.833 20.1667 168 23C167.167 23.1667 164.537 23.451 163 25.5C161.5 27.5 160 30.5 161 35Z",
  fill: "black"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M158.5 36C157.667 33.3333 157 27.2 161 24C165 20.8 169.333 21 171 21.5",
  stroke: "black",
  strokeWidth: 2
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M201 8.5C201.667 6.66667 204.5 3 210.5 3C216.5 3 219.667 6 220.5 7.5",
  stroke: "black",
  strokeWidth: 2
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M236.5 104C234.833 102.167 226.8 95.8 220 93C213.2 90.2 210.833 89.8333 210.5 90",
  stroke: "black",
  strokeWidth: 2
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M183 36.5C180.2 37.7 178.167 36.3333 177.5 35.5C176.5 34.6667 175.8 32.6 181 31C186.2 29.4 187.167 31.3333 187 32.5C186.833 33.3333 185.8 35.3 183 36.5Z",
  fill: "black"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M200.5 32.5C198.1 32.1 197 32.5 196.5 34C196.5 35.5 197 35.5 197 35.5C197 35.5 198 36.5 201.5 38C205 39.5 206 38 206 36.5C206 35 203.5 33 200.5 32.5Z",
  fill: "black"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 43.5,
  r: 2,
  fill: "black"
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  cx: 197,
  cy: 43.5,
  r: 2,
  fill: "black"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M228 50.5L223 51.5",
  stroke: "black",
  strokeWidth: 2
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M195.5 57.5C195.5 62.5 190.8 65.3 186 64.5",
  stroke: "black",
  strokeWidth: 2
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 45.5,
  r: 29,
  fill: "white",
  stroke: "black",
  strokeWidth: 2
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 45.5,
  r: 24,
  fill: "#5AE6D9"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2 42.35C19.2 43.0956 18.5956 43.7 17.85 43.7C17.1044 43.7 16.5 43.0956 16.5 42.35C16.5 41.6044 17.1044 41 17.85 41C18.5956 41 19.2 41.6044 19.2 42.35Z",
  fill: "#243041"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M22.35 45.5C23.0956 45.5 23.7 44.8956 23.7 44.15C23.7 43.4044 23.0956 42.8 22.35 42.8C21.6044 42.8 21 43.4044 21 44.15C21 44.8956 21.6044 45.5 22.35 45.5Z",
  fill: "#243041"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M40.8 42.35C40.8 43.0956 41.4044 43.7 42.15 43.7C42.8956 43.7 43.5 43.0956 43.5 42.35C43.5 41.6044 42.8956 41 42.15 41C41.4044 41 40.8 41.6044 40.8 42.35Z",
  fill: "#243041"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M37.65 45.5C36.9044 45.5 36.3 44.8956 36.3 44.15C36.3 43.4044 36.9044 42.8 37.65 42.8C38.3956 42.8 39 43.4044 39 44.15C39 44.8956 38.3956 45.5 37.65 45.5Z",
  fill: "#243041"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30 63.5C39.9411 63.5 48 55.4411 48 45.5C48 35.5589 39.9411 27.5 30 27.5C20.0589 27.5 12 35.5589 12 45.5C12 55.4411 20.0589 63.5 30 63.5ZM30.9 61.6754C39.4284 61.2084 46.2 54.145 46.2 45.5C46.2 36.553 38.947 29.3 30 29.3C21.053 29.3 13.8 36.553 13.8 45.5C13.8 54.145 20.5716 61.2084 29.1 61.6754V49.91C27.046 49.4931 25.5 47.6771 25.5 45.5C25.5 43.0147 27.5147 41 30 41C32.4853 41 34.5 43.0147 34.5 45.5C34.5 47.6771 32.954 49.4931 30.9 49.91V61.6754ZM30 48.2C31.4912 48.2 32.7 46.9912 32.7 45.5C32.7 44.0088 31.4912 42.8 30 42.8C28.5088 42.8 27.3 44.0088 27.3 45.5C27.3 46.9912 28.5088 48.2 30 48.2Z",
  fill: "#243041"
});

var SvgStartGenerating = function SvgStartGenerating(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 213,
    viewBox: "0 0 282 213",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStartGenerating, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/start_generating.7950776c.svg";
export { ForwardRef as ReactComponent };